(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var $desc = $('.SectionHeader__Description');
    if (!$desc.length) return;

    var words = $desc.text().trim().split(' ');
    if (words.length > 40) {
      $desc.addClass('truncate');
      $desc.after(
        '<p class="read-more"><span onclick="handleReadMore()" tabindex="0" aria-label="Read more about this product" role="button" aria-expanded="false">[read more]</span></p>'
      );
      window.handleReadMore = function () {
        $desc.removeClass('truncate');
        $desc.next().remove();
      };
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["responsive-collection"] && !Shopify.designMode) return;
  try {
    
	class ResponsiveCollection extends HTMLElement {
		connectedCallback() {
			this._flkty = null;
			this._mq = window.matchMedia('(max-width: 1100px)');
			this._handleChange = this._handleChange.bind(this);
			this._mq.addEventListener('change', this._handleChange);

			if (document.readyState === 'complete') {
				this._handleChange(this._mq);
			} else {
				window.addEventListener('load', () => this._handleChange(this._mq), { once: true });
			}
		}

		disconnectedCallback() {
			if (this._mq) this._mq.removeEventListener('change', this._handleChange);
			if (this._flkty) {
				this._flkty.destroy();
				this._flkty = null;
			}
		}

		_handleChange(e) {
			if (e.matches) {
				if (!this._flkty) {
					this._flkty = new Flickity(this, { wrapAround: true, autoPlay: 4000 });
				}
			} else {
				if (this._flkty) {
					this._flkty.destroy();
					this._flkty = null;
				}
			}
		}
	}

	customElements.define('responsive-collection', ResponsiveCollection);

  } catch(e) { console.error(e); }
})();
})();
